/***
 * Created on 2022/9/6
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import {
    registerApplication,
    start,
    addErrorHandler,
    getAppStatus,
    LOAD_ERROR,
    SKIP_BECAUSE_BROKEN,
    setBootstrapMaxTime,
    setMountMaxTime, unloadApplication,
} from "single-spa";


function showWhenAnyOf(routes, startWith=false) {
    return function (location) {
        if (startWith) return routes.some((route) => location.pathname.startsWith(route));
        return routes.some((route) => location.pathname === route);
    };
}

function appNavPlaceholder() {
    return `
    <div class="comp-placeholder w-full !pt-16 !pr-32 !pb-16 !pl-32">
        <div class="placeholder--nav-full !mb-32"></div>
        <div class="placeholder--nav-full !mb-32"></div>
        <div class="placeholder--nav-full !mb-32"></div>
        <div class="placeholder--nav-full !mb-32"></div>
        <div class="placeholder--nav-full !mb-32"></div>
        <div class="placeholder--nav-full !mb-32"></div>
    </div>`;
}

function appMainPlaceholder() {
    return `
    <div class="comp-placeholder w-full h-full !pt-24 !pr-32 !pb-24 !pl-32">
        <div class="placeholder--title !mb-40"></div>
        <div class="placeholder--toolbar-half !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-full !mb-24"></div>
        <div class="placeholder--text-three-quarters !mb-24"></div>
        <div class="placeholder--text-three-quarters"></div>
    </div>`;
}

function commonLoad() {
    return `<div class="comp-loading-indicator">
                <div class="loading-indicator--modern">
                    <div class="loading-indicator__modern-wrapper loading-indicator__modern-wrapper--without-content">
                        <div class="loading-indicator__anime--circular">
                            <svg class="circular" viewBox="0 0 40 40">
                                <circle class="base" cx="20" cy="20" r="16" fill="none" stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="#e5e8eb"/>
                                <circle class="path" cx="20" cy="20" r="16" fill="none" stroke-linecap="round" stroke-width="4" stroke-miterlimit="10" stroke="#001B49"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>`;
}

function loadApp(module, elemClass) {
    const isCommon = ['/', '/signin', '/switch-account', '/two-step-verification', '/signup', '/forget_password', '/resetpassword', '/force-2fa-setup', '/error', '/404'].includes(window.location.pathname);
    return Promise.resolve().then(
        () => {
            document.querySelector(`.${elemClass}`).innerHTML = commonLoad();
            // if (!isCommon) {
            //     if (elemClass === 'app-nav') {
            //         document.querySelector(`.${elemClass}`).innerHTML = appNavPlaceholder();
            //     } else {
            //         document.querySelector(`.${elemClass}`).innerHTML = appMainPlaceholder();
            //     }
            // }
            return module().catch(error => {
                // return Promise.reject('import module failed');
                return Promise.resolve(module())
            });
        }
    ).then(
        app => {
            return app;
        }
    );
}

registerApplication({
    name: 'AccMainApp',
    // app: () => import('common/AccMainApp'),
    app: () => loadApp(async () => await import('common/AccMainApp'), 'acc-mf-app'),
    activeWhen: showWhenAnyOf(['/'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.acc-mf-app'),
    }
});

/*
registerApplication({
    name: 'auth',
    app: () => loadApp(async () => await import('auth/Signin'), 'app-main'),
    activeWhen: showWhenAnyOf(['/', '/signin']),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'SwitchAccount',
    app: () => loadApp(async () => await import('auth/SwitchAccount'), 'app-main'),
    activeWhen: showWhenAnyOf(['/switch-account']),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'twostep',
    app: () => loadApp(() => import('auth/TwoStepVerification'), 'app-main'),
    activeWhen: showWhenAnyOf(['/two-step-verification']),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'SignupGlobal',
    app: () => loadApp(() => import('auth/SignupGlobal'), 'app-main'),
    activeWhen: showWhenAnyOf(['/signup']),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'ForgetPassword',
    app: () => loadApp(() => import('auth/ForgetPassword'), 'app-main'),
    activeWhen: showWhenAnyOf(['/forget_password']),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'ResetPassword',
    app: () => loadApp(() => import('auth/ResetPassword'), 'app-main'),
    activeWhen: showWhenAnyOf(['/resetpassword'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'UserWarning',
    app: () => loadApp(() => import('auth/UserWarning'), 'app-main'),
    activeWhen: showWhenAnyOf(['/security_warning'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'Header',
    app: () => import('common/Header'),
    activeWhen: showWhenAnyOf(['/'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.app-head'),
    }
});

registerApplication({
    name: 'HeaderSheet',
    app: () => import('common/HeaderSheet'),
    activeWhen: showWhenAnyOf(['/'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.comp-sheet-wrapper'),
    }
});

registerApplication({
    name: 'Footer',
    app: () => import('common/Footer'),
    activeWhen: showWhenAnyOf(['/'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.app-foot'),
    }
});

registerApplication({
    name: 'Navigator',
    app: () => loadApp(() => import('common/Navigator'), 'app-nav'),
    activeWhen: showWhenAnyOf(['/', '/account'], true),
    customProps: {
        domElementGetter: () => document.querySelector('.app-nav'),
    }
});

registerApplication({
    name: 'GlobalAlert',
    app: () => loadApp(()=>import('common/GlobalAlert'), 'app-main'),
    activeWhen: showWhenAnyOf(['/'], true),
    customProps: {
      domElementGetter: () => document.querySelector('.global-alert-wrapper'),
    }
});

registerApplication({
    name: 'StandardError',
    app: () => loadApp(()=>import('common/StandardError'), 'app-main'),
    activeWhen: showWhenAnyOf(['/error'], true),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'PageNotFound',
    app: () => loadApp(()=>import('common/PageNotFound'), 'app-main'),
    activeWhen: showWhenAnyOf(['/404'], true),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

// TODO enable this in the future, currently in the old acc there is not such feature
// registerApplication(
//     'CookieBanner',
//     () => import('common/CookieBanner'),
//     showWhenAnyOf(['/'], true),
//     {
//       domElementGetter: () => document.querySelector('.global-cookie-banner-wrapper'),
//     }
// );

registerApplication({
    name: 'Force2FA',
    app: () => loadApp(() => import('accountCenter/Force2FA'), 'app-main'),
    activeWhen: showWhenAnyOf(['/force-2fa-setup'], true),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'UserProfile',
    app: () => loadApp(() => import('accountCenter/UserProfile'), 'app-main'),
    activeWhen: showWhenAnyOf(['/account', '/account/profile'], false),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name:'Security',
    app: () => loadApp(() => import('accountCenter/Security'), 'app-main'),
    activeWhen: showWhenAnyOf(['/account/security'], false),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'Contact',
    app: () => loadApp(() => import('accountCenter/Contact'), 'app-main'),
    activeWhen: showWhenAnyOf(['/account/contact'], false),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});

registerApplication({
    name: 'Activity',
    app: () => loadApp(() => import('accountCenter/Activity'), 'app-main'),
    activeWhen: showWhenAnyOf(['/account/activity'], false),
    customProps: {
      domElementGetter: () => document.querySelector('.app-main'),
    }
});
 */

addErrorHandler(err => {
    console.error(err);
    console.error(getAppStatus(err.appOrParcelName));
    if ([SKIP_BECAUSE_BROKEN, LOAD_ERROR].includes(getAppStatus(err.appOrParcelName))) {
        // window.location.reload();
        // unloadApplication(err.appOrParcelName);
    }
});

try {
    setMountMaxTime(20000, false, 5000);
    setBootstrapMaxTime(20000, false, 5000);
    start();
} catch (err) {
    console.log('loading error')
}